import Expandable from './expandable/Expandable';

export default function initExpandables() {
    document.querySelectorAll('.expandable').forEach(expandable => {
        // eslint-disable-next-line no-new
        new Expandable(expandable);
    });
}
